import React from "react";

export function EventPageSubheaderCloseButton({
	onClick,
}: {
	onClick: React.MouseEventHandler<HTMLButtonElement>;
}) {
	return (
		<button
			type="button"
			className="header--event__close btn btn--square btn--square--sml btn--primary--inverted"
			onClick={onClick}
		>
			<i className="u-icon u-icon--tny u-icon--close" />
		</button>
	);
}
